window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoSuperbombaRepo = function () {
    var url = 'api/casinosuperbomba';

    var get = function (kampanja) {
        return fetch(url + casino.repos.base.serializeGetParams({
            kampanja: kampanja
        }), { credentials: repos.base.credentials })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    }
}();